<template>
  <label>{{ formElement.config.label }} <span v-if="!formElement.rules.required">({{
    $t("form.UMA_LANG_SASUMA_ALOJAMENTO_FORM_OPTIONAL") }})</span>
    <input v-model="formElement.value" :name="name" @input="validate(name)" type="text" required
      v-if="formElement.config.type == 'text'">
    <input v-model="formElement.value" :name="name" @input="validate(name)" type="email" required
      v-if="formElement.config.type == 'email'">
    <input v-model="formElement.value" :name="name" @input="validate(name)" type="date" required
      v-if="formElement.config.type == 'date'">
    <template v-if="formElement.config.type == 'select'">
      <select v-model="form[name].value" :name="name" @change="validate(name)">
        <option v-for="option in formElement.config.options" :value="option.value">
          {{ option.label }}
        </option>
      </select>
    </template>
    <template v-if="formElement.config.type == 'radio'">
      <template v-for="option in formElement.config.options">
        <div class="formoption">
          <input type="radio" 
            v-model="form.alunouma.value" 
            @change="validate(name)"
            :name="option.value"
            :value="option.value" 
            :id="option.value">
          <label :for="option.value">
            {{ option.label }}
          </label>
        </div>
      </template>
    </template>
    <template v-if="formElement.errors.length > 0">
      <p v-for="error in formElement.errors" class="error">
        {{ error }}
      </p>
    </template>
  </label>
</template>

<script>
export default {
  props:["formElement","form","validate","name"],
}
</script>

<style lang="scss" scoped>
label {
  font-family: "Montserrat";
  color: rgb(62, 62, 62);
  font-size: 15px;
}

input, select {
  height: 3rem;
  padding-left: .8rem;
  margin-bottom: 0;
  font-family: "PT Sans";
  font-size: 16px;
  color: #a7a5a5;
  margin-top: 5px;
  border-radius: 0;
  border-color: rgb(62, 62, 62);
}

input[type="radio"] {
  height: auto;
  margin-right: 0;
}

[type=radio]+label[for] {
  margin: 0;
}

textarea {
  border-color: rgb(62, 62, 62);
  margin-top: 5px;
  margin-bottom: 0;
  font-family: "PT Sans";
  font-size: 16px;
  color: #a7a5a5;
  padding-left: .8rem;
}

label.outrolabel {
  width: 97.8%;
  margin-right: 0;
}

input[type=checkbox] {
  height: auto;
}

.checkoptions .row:first-of-type {
  margin-top: 20px;
}

.formoption {
  display: block;
  margin-right: 12px;
}

.formoption:first-of-type {
  margin-bottom: 10px;
  margin-top: 10px;
}

.error {
  color: red;
}
</style>